var React = require('react');

function IcCamera (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M5 7h10a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2zm13.996 8.182A4 4 0 0115 19H5a4 4 0 01-4-4V9a4 4 0 014-4h10a4 4 0 013.996 3.818L23 6v12l-4.004-2.818zM19 12.739l2 1.408V9.854l-2 1.407v1.478z","clipRule":"evenodd"}));
}

IcCamera.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcCamera;

IcCamera.default = IcCamera;
